export default {
  SENT: 'sent',
  DRAFT: 'draft',
  SENT_LABEL: 'Sent',
  DRAFT_LABEL: 'Draft',
};
